import { forEach, trim } from 'lodash';
/**
 * Convert URLs in a string to anchor links
 * https://codepen.io/zuhairtaha/pen/NmbGKJ
 */
export const URLify = (s: string) => {
  let result = s;
  const urls = result.match(
    /[(http(s)?)://(www.)?a-zA-Z0-9@:%._+~#=]{2,256}\.([a-z]{2}|com)(\.[a-z]{2})?\b([-a-zA-Z0-9@:%_+.~#?&//=]*)/gm,
  );
  if (urls) {
    forEach(urls, (urlWithSpace) => {
      const howManySimilarUrls = result.match(new RegExp(urlWithSpace, 'g'))!.length;
      let url = urlWithSpace;
      let prefix = '';
      let postFix = '';
      if (urlWithSpace.indexOf(' ') === 0) {
        url = trim(urlWithSpace);
        prefix = ' ';
      }
      if (urlWithSpace[urlWithSpace.length - 1] === '.') {
        url = urlWithSpace.substring(0, urlWithSpace.length - 1);
        postFix = '.';
      }
      const hasUrlHttp = /http/.test(url);
      let urlCount = 0;
      result = result.replace(new RegExp(urlWithSpace, 'g'), (match: string) => {
        if (urlCount++ < howManySimilarUrls - 1) {
          return match;
        }
        return `${prefix}<a target="_blank" href="${hasUrlHttp ? '' : 'https://'}${url}">${url}</a>${postFix}`;
      });
    });
  }
  return result.replace('(', '<br/>(');
};
